import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/fontawesome/css/fontawesome.css';
import './assets/fontawesome/css/brands.css';
import './assets/fontawesome/css/solid.css';
import './assets/css/styles.scss';
import './App.css';

import 'bootstrap/dist/js/bootstrap.min.js';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { Navigation } from './components/Navigation';
import { Home } from './components/Home';
import { Footer } from './components/Footer';

function App() {
  return (
    <div className="bg-hero">
      <Router>
        <header>
            <Navigation />
        </header>

        <main>
          <Routes>
            <Route exact path="/" element={ <Home /> } />
          </Routes>
        </main>

        <footer>
          <Footer />
        </footer>
          
      </Router>
    </div>
  );
}

export default App;
